import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { ApplyInternalJobPostRequest } from './types';

import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { jobPostQueryOptions } from './useJobPost';

export const useApplyInternalJobPost = (jobPostId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: ApplyInternalJobPostRequest) =>
      fetchJson(`/job-posts/${jobPostId}/apply`, {
        method: 'POST',
        body,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries(jobPostQueryOptions(jobPostId));
      queryClient.invalidateQueries({ queryKey: QueryKeys.jobPosts.index.root });
    },
  });
};
